/**
 * Dashboard — campaign hero, party overview, session log, dice roller.
 * Stub: visible-but-empty layout matching the mockup's regions so routing works.
 */
export default function Dashboard() {
  return (
    <div>
      <h1>Dashboard</h1>
      <p className="sheet-a">Campaign hero · party · session log · dice roller</p>
      <p>This page is a scaffold. Build out from the dashboard mockup next.</p>
    </div>
  );
}
